import * as IoC from 'typescript-ioc';

import { IApiClient } from '../../infrastructure/api-client';
import * as ROLES_API from '../../constants/api/roles-api';
import {
    ICreateRoleDTO,
    IGetRolePermissionsDTO, IPutRolePermissionsDTO, IRoleDTO,
    IRolesDAO, IRolesDTO,
    IRolesListDTO
} from '../roles.dao';

class RolesDAO extends IRolesDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getRoles(params?: {nextPageToken?: string}): Promise<IRolesListDTO> {
        const response = await this.apiClient.get<IRolesListDTO>(ROLES_API.ROLES_LIST_URL, params || {});
        return response.parsedResponse;
    }

    public async getAllRoles(): Promise<IGetRolePermissionsDTO[]> {
        const response = await this.apiClient.get<IGetRolePermissionsDTO[]>(ROLES_API.ROLES_ALL_LIST_URL);
        return response.parsedResponse;
    }

    public async createRole(params: ICreateRoleDTO): Promise<void> {
        await this.apiClient.post<ICreateRoleDTO>(
            ROLES_API.NEW_ROLE_URL, params
        );
    }

    public async getPermissionsByRoleId(params: Partial<IRolesDTO>): Promise<IGetRolePermissionsDTO> {
        const response = await this.apiClient.get<IGetRolePermissionsDTO>(
            ROLES_API.ROLE_URL, params
        );
        return response.parsedResponse;
    }

    public async updateRolePermissions(params: IPutRolePermissionsDTO): Promise<void> {
        await this.apiClient.put<IPutRolePermissionsDTO>(
            ROLES_API.PUT_ROLE_PERMISSIONS_URL, params
        );
    }

    public async updateRole(params: IRoleDTO): Promise<void> {
        await this.apiClient.put<IGetRolePermissionsDTO>(
            ROLES_API.ROLE_URL, params
        );
    }

    public async deleteRole(params: Partial<IRolesDTO>): Promise<void> {
        await this.apiClient.delete<void>(
            ROLES_API.ROLE_URL, params
        );
    }
}

export { RolesDAO };
